import React from "react";
import { IPersonalInformation } from "../../../../store/credit/types";

interface IProps {
    data?: IPersonalInformation[];
}
const PrintCreditHistoryPersonalInfo: React.FunctionComponent<IProps> = (props) => {
    let col = null;
    if (props.data != null) {
        col = props.data;
    }

    return (
        <React.Fragment>
            <div className="box offset-padding">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-text">
                            <h2 className="box-title" id="print-credit-history-personal-info">
                                Personal Information
                            </h2>
                        </div>
                    </div>
                    <div className="box-description"></div>
                    <div className="box-actions"></div>
                </div>
                <div className="box-content">
                    <div className="table-container scroll">
                        {col != null ? (
                            <table className="m-table-generic">
                                <thead>
                                    <tr>
                                        <th scope="col">
                                            <span className="sr-only"></span>
                                        </th>
                                        {col.map((personalInfo: IPersonalInformation) => (
                                            <th key={personalInfo.bureau} scope="col">
                                                {personalInfo.bureau}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row" className="table-label">
                                            Name
                                        </th>
                                        {col.map((personalInfo: IPersonalInformation) => (
                                            <td key={personalInfo.bureau + personalInfo.borrowerName + "_personalInfoName"}>{personalInfo.borrowerName}</td>
                                        ))}
                                    </tr>
                                    <tr>
                                        <th scope="row" className="table-label">
                                            Date of Birth
                                        </th>
                                        {col.map((personalInfo: IPersonalInformation) => (
                                            <td key={personalInfo.bureau + personalInfo.borrowerName + "_personalInfoDOB"}>{personalInfo.birth}</td>
                                        ))}
                                    </tr>
                                </tbody>
                            </table>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PrintCreditHistoryPersonalInfo;
